
import { debounceTime } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { AuthService } from '../../shared/services/auth/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { AssociateService } from '../../associate/shared/services/associate.service';
import { OrganizationService } from '../../shared/services/organization.service';
import { WorkgroupService } from '../../work-groups/workgroup-services/workgroup.service';
import { TimelineService } from '../../associate/shared/services/timeline.service';
import * as io from 'socket.io-client';
import { Configuration } from '../../app.constants';
import { MatAutocomplete } from '@angular/material';
import { NotificationService } from '../../shared/services/notification.service';
import { SocketService } from 'app/shared/services/socket.service';
import * as $ from 'jquery';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    public shouldSearch: Boolean = true;
    // variables for ACL
    public isAdmin: Boolean = false;
    public associate: JSON;
    public isLeader: Boolean = false;
    public searchText: string;
    public user: any;
    public notificationSocket: any;
    public archiveSocket: any;
    isLoggedIn$: Observable<boolean>;                  // {1}
    public associates = [];
    public organizations = [];
    public sites = [];
    public legalEntities = [];
    public teams = [];
    public lists = [];
    public socket: any;
    public workgroups = [];
    public isNewNotification = false;
    public notifications = []
    public imagePlaceholder = 'assets/img/profile/blank-profile.png';
    public associateImageUrl: string;
    public searchNameBeh = new BehaviorSubject<string>('');
    public searchNameObs = this.searchNameBeh.asObservable();
    public obserablesArr = [];
    // variables for changing password flow
    public userId;
    public forgotPasswordString;
    @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;
    public organizationQuery = {
        search: {
            'active': true,
            'company.companyName': { $regex: '', $options: 'i' }
        },
        sort: {
            'company.companyName': 1
        },
        pagination: {
            pageIndex: 0,
            pageSize: 1
        }
    };
    public associateQuery = {
        search: {
            'active': true,
            'personalInformation.fullName': { '$regex': '', '$options': 'i' },
        },
        sort: { 'personalInformation.fullName': 1 },
        pagination: {
            pageIndex: 0,
            pageSize: 1
        }
    };
    public siteQuery = {
        search: {
            'active': true,
            'siteDetails.siteName': { $regex: '', $options: 'i' }
        },
        sort: {
            'siteDetails.siteName': 1
        },
        pagination: {
            pageIndex: 0,
            pageSize: 1
        }
    };
    public legalEntityQuery = {
        search: {
            'active': true,
            'legalEntityName': { $regex: '', $options: 'i' }
        },
        sort: {
            'legalEntityName': 1
        },
        pagination: {
            pageIndex: 0,
            pageSize: 1
        }
    };

    public serverApiUrl;

    constructor(public authService: AuthService,
        public assc: AssociateService,
        public organizationService: OrganizationService,
        public workGroupService: WorkgroupService,
        public timelineService: TimelineService,
        public config: Configuration,
        public notificationService: NotificationService,
        public router: Router,
        private socketService: SocketService) {
    }
    nameSearched() {
        this.searchNameBeh.next(this.searchText);
    }

    ngOnInit() {
        this.serverApiUrl = this.config.StaticImageUrl;
        this.obserablesArr.push(this.searchNameObs.pipe(debounceTime(700)).subscribe(value => {
            this.intialAssociates(value);
        }));
        this.authService.displayImageUrlObs.subscribe((data) => {
            if (data) {
                this.associateImageUrl = data;
            }
        });
        // this.socket = io(this.config.SocketUrl);
        // this.notificationSocket = io(this.config.SocketUrl);
        // this.archiveSocket = io(this.config.SocketUrl);
        this.user = this.authService.user;
        this.userId = this.user.userId;
        this.forgotPasswordString = this.user.forgotPasswordString;
        console.log('User', this.user);
        if (this.user.role === 'Admin') {
            this.isAdmin = true;
            this.isLeader = false;
        } else if (this.user.role === 'OpCo Manager' || this.user.role === 'HR Manager') {
            this.isAdmin = false;
            this.isLeader = true;
        }
        this.isLoggedIn$ = this.authService.isLoggedIn; // {2}
        this.searchText = '';

        this.assc.getAssociate(this.user.associateId).subscribe(associates => {
            this.associate = associates['data'][0];
            if (this.associate['unreadNewNotifications']) {
                this.isNewNotification = true;
            }
            if (!this.associate['active'] && this.associate['_id'] === this.user.associateId) {
                this.onLogout();
            }
            this.associateImageUrl = this.config.StaticImageUrl + this.associate['personalInformation']['avatarUrl'];
            if (this.associate['personalInformation']['gender'].includes('Male')) {
                this.imagePlaceholder = 'assets/img/Male-orange.png'
            } else if (this.associate['personalInformation']['gender'].includes('Female')) {
                this.imagePlaceholder = 'assets/img/Female-orange.png'
            }

            // this.socketListner();
        });

        // this.archiveSocket.on(`archive-${this.authService.user.associateId}`, function(data){
        //     console.log('logout ', `archive-${this.authService.user.associateId}`)
        //     if (data) {
        //         this.onLogout();
        //     }
        // }.bind(this));

        // console.log(`refresh-${this.authService.user.associateId}`)
        // this.socket.on(`refresh-${this.authService.user.associateId}`, function(data){
        //     if (data) {
        //         window.location.reload(true);
        //         this.router.navigate(['/disclaimer']);
        //     }
        // }.bind(this));

        this.timelineService.getAllNotifications(this.user.associateId).subscribe(
            data1 => {
                this.notifications = Object.assign([], data1).slice(0, 5);
                // this.notificationSocket.on(`notifications-${this.user.associateId}`, function (data) {
                //     this.notifications.unshift(data);
                //     this.isNewNotification = true;
                // }.bind(this));
            }, err => {
            });

    }

    socketListner() {
        this.socketService.archiveObs.subscribe(res => {
            if (res) {
                this.onLogout();
            }
        });

        this.socketService.refreshObs.subscribe(res => {
            if (res) {
                window.location.reload(true);
                this.router.navigate(['/disclaimer']);
            }
        });

        this.socketService.notificationObs.subscribe(notification => {
            if (notification !== undefined) {
                this.notifications.unshift(notification);
                this.isNewNotification = true;
            }
        });
    }

    readNotifications() {
        this.isNewNotification = false;
        this.notificationService.readAllunreadNotifications(this.authService.user.associateId);
    }

    onLogout() {
        this.authService.logout();                      // {3}
    }

    register() {
        this.router.navigate(['/register']);
    }

    saveSearchHistory(name, category, id, extrainfo?) {
        for (let i = 0; i < 5 && i < this.associate['powerSearchHistory']; i++) {
            if (this.associate['powerSearchHistory'][i].id === id) {
                return;
            }
        }

        this.associate['powerSearchHistory'].unshift({ name: name, id: id, componentType: category, extrainfo: extrainfo });
        // this.associate['powerSearchHistory'] = this.associate['powerSearchHistory'].splice(0, 5);
        this.assc.updateAssociate(this.associate).subscribe(res => { }, error => {
            console.log('associate header', error);
        })
    }

    chooseFirstOption(): void {
        if (this.matAutocomplete.options.first.active) {
            this.matAutocomplete.options.first.select();
        } else { }
    }

    clickDropDown(category, id, extraId?) {
        console.log('1');
        this.shouldSearch = false;
        this.searchText = '';
        if (category === 'associate') {
            this.router.navigate(['/home/associate/profile/view', id]);
        } else if (category === 'organization') {
            this.router.navigate(['/home/organization/profile/view', id]);
        } else if (category === 'sites') {
            this.router.navigate(['/home/organization/site-profile/view', id]);
        } else if (category === 'legalEntities') {
            this.router.navigate(['/home/legal-entity/update-legal-entity/', id]);
        } else if (category === 'workgroup') {
            this.router.navigate(['/home/working-group/profile/', id]);
        } else if (category === 'teams') {
            this.router.navigate(['/home/organization/team-profile/view/', id, extraId]);
        } else if (category === 'list') {
            this.router.navigate(['/home/list/profile', id]);
        }
        this.searchText = '';
        this.associates = [];
        this.organizations = [];
        this.sites = [];
        this.legalEntities = [];
        this.teams = [];
        this.lists = [];
        this.workgroups = [];
    }
    checkResponsesCount(count) {
        this.matAutocomplete.options.first.setActiveStyles();
    }

    intialAssociates(event) {
        this.shouldSearch = true;
        if (event !== '' && this.shouldSearch) {
            // get associates
            let countFnResponses = 0;
            this.associateQuery.search['personalInformation.fullName'] = { $regex: this.searchText, $options: 'i' };
            this.assc.powerSearch(
                this.associateQuery.pagination.pageIndex,
                this.associateQuery.pagination.pageSize,
                this.associateQuery.search,
                this.associateQuery.sort).then((data) => {
                    countFnResponses++;
                    this.checkResponsesCount(countFnResponses);
                    this.associates = data['data'];
                }, (error) => {
                    console.log(error);
                });
            // get organizations
            this.organizationQuery.search['company.companyName'] = { $regex: this.searchText, $options: 'i' };
            this.organizationService.powerSearch(
                this.organizationQuery.pagination.pageIndex,
                this.organizationQuery.pagination.pageSize,
                this.organizationQuery.search,
                this.organizationQuery.sort).then((data) => {
                    countFnResponses++;
                    this.checkResponsesCount(countFnResponses);
                    this.organizations = data['data'];
                }, (error) => {
                    console.log('No organizations', error);
                });
            // get sites
            this.siteQuery.search['siteDetails.siteName'] = { $regex: this.searchText, $options: 'i' };
            this.organizationService.powersearchSites(
                this.siteQuery.pagination.pageIndex,
                this.siteQuery.pagination.pageSize,
                this.siteQuery.search,
                this.siteQuery.sort
            ).subscribe((data) => {
                countFnResponses++;
                this.checkResponsesCount(countFnResponses);
                this.sites = data['data'];
            }, (error) => {
                console.log('No sites', error);
            });
            // get legalEntities only for admin, hr-leader and opco-leader
            if (this.isAdmin || this.isLeader) {
                this.legalEntityQuery.search['legalEntityName'] = { $regex: this.searchText, $options: 'i' };
                this.organizationService.powergetAllLegalEntities(
                    this.legalEntityQuery.pagination.pageIndex,
                    this.legalEntityQuery.pagination.pageSize,
                    this.legalEntityQuery.search,
                    this.legalEntityQuery.sort
                ).subscribe((data) => {
                    countFnResponses++;
                    this.checkResponsesCount(countFnResponses);
                    this.legalEntities = data['data'];
                }, (error) => {
                    console.log('No sites', error);
                });
            }
            // get WorkGroups
            this.workGroupService.getWorkGroupsByName(this.searchText).subscribe((data) => {
                this.workgroups = data['data'];
                countFnResponses++;
                this.checkResponsesCount(countFnResponses);
            }, (error) => {
                console.log('Work Groups Error', error);
            });

            // get Teams
            this.organizationService.teamSearch(this.searchText).subscribe((data) => {
                this.teams = data['data'];
                countFnResponses++;
                this.checkResponsesCount(countFnResponses);
            }, (error) => {
                console.log('No Teams', error);
            });
            // get lists of this associate
            this.assc.getAssociate(this.authService.user.associateId).subscribe((data) => {
                countFnResponses++;
                this.checkResponsesCount(countFnResponses);
                this.lists = data['data'][0].listManagment;
            }, (error) => {
            });
        }
    }

    powerSearchRoute() {
        this.shouldSearch = false;
        this.router.navigate([`/home/associate/power-search/${this.searchText}`]);
    }

    rerouteToNotification(urlToRoute) {
        this.router.navigate([urlToRoute]);
    }

    proxyLogout() {
        this.authService.proxyLogout()
            .then()
            .catch();
    }

    hideSidebar() {
        $("body").toggleClass("min");
    }
}
